// extracted by mini-css-extract-plugin
export default {"banner1":"Banner1_banner1__2YqJn","banner1Wrapper":"Banner1_banner1Wrapper__4T9iE","banner1Heading":"Banner1_banner1Heading__u8VxY","banner1Btn":"Banner1_banner1Btn__UnHD6"};